type FastApiDetailItem = { loc?: (string | number)[]; msg?: string };

export function parseFastApiValidationMessage(detail: unknown): string {
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((item: FastApiDetailItem) => item.msg || JSON.stringify(item))
      .filter(Boolean)
      .join(' ');
  }
  return 'Request could not be validated.';
}

export interface ApiErrorDetail {
  code: string | null;
  message: string;
}

/** Extract FastAPI's string, validation array, or structured detail payload. */
export function extractApiErrorDetail(
  error: unknown,
  fallbackMessage: string,
): ApiErrorDetail {
  const responseDetail = (
    error as { response?: { data?: { detail?: unknown } } } | null
  )?.response?.data?.detail;

  if (responseDetail && typeof responseDetail === 'object' && !Array.isArray(responseDetail)) {
    const detail = responseDetail as Record<string, unknown>;
    return {
      code: typeof detail.code === 'string' ? detail.code : null,
      message:
        typeof detail.message === 'string' && detail.message.trim()
          ? detail.message
          : fallbackMessage,
    };
  }

  if (typeof responseDetail === 'string' || Array.isArray(responseDetail)) {
    return {
      code: null,
      message: parseFastApiValidationMessage(responseDetail),
    };
  }

  return {
    code: null,
    message: error instanceof Error && error.message ? error.message : fallbackMessage,
  };
}
